const mainData = [
   {
      id: 1,
      year: 2016,
      userGain: 80000,
      userLost: 823,
      print:0,
      tvNews:40000,
      digital:75000,
      radio:0,
  
      positive:40000,
      neutral:75000,
      negative:90000,
      trend:90000,
    },
  {
    id: 1,
    year: 2016,
    userGain: 80000,
    userLost: 823,
    print:60000,
    tvNews:40000,
    digital:75000,
    radio:90000,

    positive:40000,
    neutral:75000,
    negative:90000,
    trend:90000,
  },
  {
    id: 2,
    year: 2017,
    userGain: 45677,
    userLost: 345,
    print:30000,
    tvNews:15000,
    digital:12345,
    radio:89000,

    positive:15000,
    neutral:12345,
    negative:89000,
    trend:89000,
  },
  {
    id: 3,
    year: 2018,
    userGain: 78888,
    userLost: 555,
    print:10000,
    tvNews:20000,
    digital:56789,
    radio:48000,
    
    positive:20000,
    neutral:56789,
    negative:48000,
    trend:48000,
  },
  {
    id: 4,
    year: 2019,
    userGain: 90000,
    userLost: 4555,
    print:15000,
    tvNews:37899,
    digital:99999,
    radio:87657,

    positive:37899,
    neutral:99999,
    negative:87657,
    trend:87657,
  },
  {
    id: 5,
    year: 2020,
    userGain: 4300,
    userLost: 234,
    print:6000,
    tvNews:65765,
    digital:34567,
    radio:16323,

    positive:65765,
    neutral:34567,
    negative:16323,
    trend:16323
  }
];

export const barChartData = [
  {
     id: 1,
     month: 'January',
     userLost: 823,
  },
  {
     id: 2,
     month: 'February',
     userLost: 823,
  },
  {
     id: 3,
     month: 'March',
     userLost: 750,
  },
  {
     id: 4,
     month: 'April',
     userLost: 678,
  },
  {
     id: 5,
     month: 'May',
     userLost: 500,
  },
  {
     id: 6,
     month: 'June',
     userLost: 420,
  },
  {
     id: 7,
     month: 'July',
     userLost: 340,
  },
  {
     id: 8,
     month: 'August',
     userLost: 260,
  },
  {
     id: 9,
     month: 'September',
     userLost: 180,
  },
  {
     id: 10,
     month: 'October',
     userLost: 100,
  },
  {
     id: 11,
     month: 'November',
     userLost: 500,
  },
  {
     id: 12,
     month: 'December',
     userLost: 300,
  },
 ];

export const Data = mainData.map(item => ({
    ...item,
    userGain: Math.floor(item.userGain / 10),
    userLost: Math.floor(item.userLost / 10),
    print: Math.floor(item.print / 10),
    tvNews: Math.floor(item.tvNews / 10),
    digital: Math.floor(item.digital / 10),
    radio: Math.floor(item.radio / 10),
    positive: Math.floor(item.positive / 10),
    neutral: Math.floor(item.neutral / 10),
    negative: Math.floor(item.negative / 10),
    trend: Math.floor(item.trend / 10),
}));
